import * as MorphSVGPlugin from "./MorphSVGPlugin"
import * as DrawSVGPlugin from "./DrawSVGPlugin"
import * as SplitText from "./SplitText"

export * from "gsap"
export { MorphSVGPlugin, DrawSVGPlugin, SplitText }
